import React from 'react';
import { Form, Button } from 'react-bootstrap';

const RegisterPage = () => {
    const styles = {
        container: {
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f8f9fa',
        },
        formContainer: {
            maxWidth: '450px',
            width: '100%',
            backgroundColor: '#fff',
            padding: '20px 30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
        },
        logo: {
            width: '80px',
            marginBottom: '20px',
        },
        googleButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
            padding: '10px 20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            backgroundColor: '#fff',
            cursor: 'pointer',
        },
        googleIcon: {
            width: '20px',
            marginRight: '10px',
        },
        submitButton: {
            width: '100%',
            backgroundColor: '#0043AA',
            borderColor: '#0043AA',
        },
        footerText: {
            marginTop: '15px',
            fontSize: '14px',
        },
        link: {
            color: '#0043AA',
            textDecoration: 'none',
        },
        p:{
            fontSize : '14px'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.formContainer}>
                <img src = '/assets/logoWhite.png' alt="Logo" style={styles.logo} />
                <h3>Create Account</h3>
                <p style={styles.p}>Join the Action – Create Your Account and Get Started Today!</p>

                <div style={styles.googleButton}>
                    <img src='/assets/google.png' alt="Google Icon" style={styles.googleIcon} />
                    Continue with Google
                </div>

                <p >or Sign in with email</p>

                <Form>
                    <Form.Group controlId="formEmail" className="text-start">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="mail@abc.com" />
                    </Form.Group>

                    <Form.Group controlId="formPassword" className="text-start mt-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Enter your password" />
                    </Form.Group>

                    <Form.Group controlId="formPassword" className="text-start mt-3">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control type="password" placeholder="Enter your password" />
                    </Form.Group>

                    <Form.Group controlId="formRememberMe" className="mt-3 d-flex justify-content-between align-items-center">
                        <Form.Check type="checkbox" label="Remember Me" />
                    </Form.Group>

                    <Button type="submit" href='/' className="mt-3" style={styles.submitButton}>
                       Register
                    </Button>
                </Form>

                <p style={styles.footerText}>
                    Already Registered Yet? <a href="/login" style={styles.link}>Login</a>
                </p>
            </div>
        </div>
    );
};

export default RegisterPage;